export const companyNameToDomainName = (companyName)=>companyName.toLowerCase().split(' ').join('-');
